import {
  ButtonBase,
  Stack,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import {
  isMobileBurgerMenuOpenAtom,
  selectedCategoryDataAtom,
  selectedMobileBurgerTabDataAtom,
} from 'store/private/layout/layoutAtoms';

import { useNavLinks } from '../navLinks';

const SPECIAL_CATEGORY_NAMES = ['search', 'windows'];

export const CategoryLinks = props => {
  const { direction } = props;
  const [, setIsMobileBurgerMenuOpen] = useAtom(isMobileBurgerMenuOpenAtom);
  const [selectedCategoryData, setSelectedCategoryData] = useAtom(
    selectedCategoryDataAtom,
  );
  const { categoriesLinks } = useNavLinks();

  const [, setSelectedMobileBurgerTabData] = useAtom(
    selectedMobileBurgerTabDataAtom,
  );

  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    if (!categoriesLinks.length) return;
    if (SPECIAL_CATEGORY_NAMES.includes(selectedCategoryData.name)) return;

    const isSelectedVisible = categoriesLinks.some(
      category => category.name === selectedCategoryData.name,
    );

    if (!isSelectedVisible) {
      setSelectedCategoryData(categoriesLinks[0]);
    }
  }, [categoriesLinks, selectedCategoryData, setSelectedCategoryData]);

  const handleClick = category => {
    setSelectedCategoryData(category);
    if (isBelowMd) {
      setIsMobileBurgerMenuOpen(true);
      setSelectedMobileBurgerTabData(category);
    }
  };

  return (
    <Container
      w="100%"
      direction={direction}
      justifyContent={direction === 'column' ? 'center' : 'space-between'}
      spacing={direction === 'column' ? 2 : 0}
    >
      {categoriesLinks.map(category => (
        <Btn
          key={category.id}
          selected={category.id === selectedCategoryData.id}
          onClick={() => handleClick(category)}
        >
          {category.icon}
        </Btn>
      ))}
    </Container>
  );
};

const Container = styled(Stack)`
  ${({ direction }) => ({
    flexWrap: direction === 'row' ? 'wrap' : 'nowrap',
    gap: direction === 'row' ? '15px' : 0,
  })}
`;

const Btn = styled(ButtonBase)`
  ${({ theme, selected }) => ({
    backgroundColor: selected ? '#0A395B' : 'transparent',
    border: selected ? `1px solid ${theme.palette.layout.borderBlue}` : 'unset',
    boxShadow: selected ? theme.shadows[3] : 'unset',
    width: '40px',
    color: 'white',
    borderRadius: '2px',
    height: '37px',
    [theme.breakpoints.down('md')]: {
      'width': '64px',
      'height': '59px',
      '& .MuiSvgIcon-root': {
        fontSize: '28px',
      },
    },
  })}
`;
